export default {
    id: 'violet-blue-green',
    colors: ['#6B32C9', '#57ABFF', '#79E0BF'],
};
